<script setup lang="ts">
import { Head, router } from "@inertiajs/vue3";
import { googleAuthCodeLogin, googleTokenLogin } from "vue3-google-login";

const error = defineModel<string | null>("error");

const login = () => {
  googleTokenLogin().then((response) => {
    // console.log("Handle the response", response);
    loginWithToken(response.access_token);
  });

  //   googleAuthCodeLogin().then((response) => {
  //     console.log("Handle the response", response);
  //     loginWithToken(response.code);
  //   });
};

const loginWithToken = (token: string) => {
  router.post(
    route("auth.google.login"),
    { token },
    {
      onBefore: (visit) => {},
      onStart: (visit) => {},
      onProgress: (progress) => {},
      onSuccess: (response) => {
        console.log(response);
      },
      onError: (errors) => {
        console.error(errors);
        error.value = errors.error;
      },
    }
  );
};
</script>

<template>
  <Head title="Log in" />

  <img alt="" src="../../../assets/images/clark-clifton-bg.jpg" class="bg-image" />
  <div class="login-view">
    <img
      class="curve"
      alt=""
      src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEwOTEgMTQ0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxuczpzZXJpZj0iaHR0cDovL3d3dy5zZXJpZi5jb20vIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjI7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDAuNzg0MzMzLDAsMCwwLjk5ODYxMywtOTE0LjMyNCwzLjk5NDQ1KSI+CiAgICAgICAgPHBhdGggZD0iTTExNjUuNzQsMTQzOEMxNzMwLjE2LDEyNTIuODMgMjE4MS44Miw4NzQuMzg5IDIzNTEuMDksMzc4LjU1OUMyMzk0LjY4LDI1MC44NjggMjQxNy4xMiwxMjIuNTk5IDI0MjAuMSwtNEwyNTU4LC00TDI1NTgsMTQzOEwxMTY1Ljc0LDE0MzhaIiBzdHlsZT0iZmlsbDp3aGl0ZTsiLz4KICAgIDwvZz4KPC9zdmc+Cg=="
    />
    <div class="login-view-container">
      <div class="login-box-container">
        <div class="d-flex flex-column justify-content-center align-items-center gap-5">
          <img
            alt="Clark Logo"
            src="../../../assets/images/clark-400px.png"
            class="clark-logo"
          />
          <div class="d-flex gap-1 form-heading">
            <span class="fw-bold">DW</span>
            <span class="fw-lighter">Extractor</span>
          </div>

          <div
            class="flex-fill alert alert-danger text-center p-2 px-4 mb-4"
            v-if="error"
          >
            {{ error }}
          </div>

          <button
            class="btn btn-outline-primary d-flex align-items-center gap-2"
            @click="login"
          >
            <i class="pi pi-google" /> <span>Sign in with Google</span>
          </button>
        </div>
      </div>
    </div>

    <section class="brands">
      <img class="brand-polly" src="../../../assets/images/brands/1.png" alt="Polly" />
      <img class="brand-tom" src="../../../assets/images/brands/2.png" alt="Tom" />
      <img class="brand-anorak" src="../../../assets/images/brands/3.png" alt="Anorak" />
      <img
        class="brand-winston"
        src="../../../assets/images/brands/4.png"
        alt="Winston"
      />
    </section>
  </div>
</template>

<style scoped>
.bg-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  object-position: left center;
  z-index: -1;
}

.clark-logo {
  width: 190px;
}

.login-view {
  position: absolute;
  right: 0;
  background: #fff;
  width: 100%;

  @media (min-width: 768px) {
    width: 400px;
  }

  @media (min-width: 1024px) {
    width: 450px;
  }
}

.login-view-container {
  position: relative;
  top: 0;
  height: 100vh;
  width: 100%;
  z-index: 1;
  display: flex;
  justify-content: center;
}

.login-box-container {
  margin-top: 10rem;
}

.form-heading {
  font-size: 4rem;
}

.curve {
  position: absolute;
  top: 0;
  right: calc(100% - 60px);
  height: 100vh;
  z-index: -1;
  filter: drop-shadow(-5px 0 1rem rgba(0, 0, 0, 0.65));
}

.brands {
  position: absolute;
  bottom: 4rem;
  left: 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  justify-content: space-around;
  gap: 2rem;
}

.brands img {
  justify-self: center;
}

.brands .brand-polly {
  height: 27px;
}

.brands .brand-tom {
  height: 20px;
}

.brands .brand-anorak {
  height: 25px;
}

.brands .brand-winston {
  height: 20px;
}
</style>
